module.exports = __webpack_public_path__ + "static/img/cheer0.25981c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/cheer/cheer0.jpg
// module id = HNWr
// module chunks = 1